/**
 * Configuration for Design System (DS) route styling.
 * Routes listed here will load new-crm-theme.css instead of crm-theme.css.
 *
 * When migrating a page to Design System components:
 * 1. Add the route to the appropriate array below
 * 2. Increment styleVersion in all environment files
 */

export interface DsRoutesConfig {
  /** Exact routes for both mobile & desktop */
  exactRoutes: string[];

  /** Mobile-only exact routes */
  mobileExactRoutes: string[];

  /** Desktop-only route patterns (contains check) */
  desktopPatterns: string[];

  /** Mobile-only route patterns (contains check) */
  mobilePatterns: string[];
}

export const DS_ROUTES_CONFIG: DsRoutesConfig = {
  // Exact routes that use DS on both mobile and desktop
  exactRoutes: [
    '/dashboard',
    '/dashboard/reports',
    '/quotes',
    '/orders',
    '/ln-orders',
    '/invoices',
    '/accounts',
    '/leads'
  ],

  // Mobile-only exact routes (desktop uses legacy theme)
  mobileExactRoutes: [
    '/quotes',
    '/orders',
    '/accounts',
    '/leads',
    '/touchpoints'
  ],

  // Desktop-only route patterns (contains check)
  desktopPatterns: [
    '/dashboard/',
    '/quotes/',
    '/ln-orders/',
    '/invoices/',
    '/accounts/',
    '/accounts-leads/',
    '/leads/',
    '/touchpoints'
  ],

  // Mobile-only route patterns (contains check)
  mobilePatterns: [
    '/quotes/',
    '/accounts/',
    '/accounts-leads/',
    '/leads/'
  ]
};
